// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.gruposTelegram .actAzul {
width: 25vh;
}
.field-larger .actGreen{
    width: 15vh;
    height: 3vh;
}`, "",{"version":3,"sources":["webpack://./src/components/config-components/MediosDifusion/PlantillasTelegram/styles/gruposTelegram.css"],"names":[],"mappings":"AAAA;AACA,WAAW;AACX;AACA;IACI,WAAW;IACX,WAAW;AACf","sourcesContent":[".gruposTelegram .actAzul {\r\nwidth: 25vh;\r\n}\r\n.field-larger .actGreen{\r\n    width: 15vh;\r\n    height: 3vh;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
